/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of category the user is allowed to select when submitting feedback.
 */
export var FeedbackCategoryOptions;
(function (FeedbackCategoryOptions) {
    FeedbackCategoryOptions["UI_BUG"] = "UI Bug";
    FeedbackCategoryOptions["INCOMPLETE_RESPONSE"] = "Incomplete response";
    FeedbackCategoryOptions["DID_NOT_FULLY_FOLLOW_MY_REQUEST"] = "Did not fully follow my request";
    FeedbackCategoryOptions["OVERACTIVE_REFUSAL"] = "Overactive refusal";
    FeedbackCategoryOptions["OTHER"] = "Other";
    FeedbackCategoryOptions["NOT_FACTUALLY_CORRECT"] = "Not factually correct";
})(FeedbackCategoryOptions || (FeedbackCategoryOptions = {}));
